export class ContaPesquisa {

      aReceber: boolean = false;
      recebido: boolean = false;
      vencido: boolean = false;
      cancelado: boolean = false;
      estornado: boolean = false;
      possuiNFSe: boolean = false;
      possuiNFe: boolean = false;
      naoPossuiNF: boolean = false;
      parceiroId: number = 0;
      empresaId: number = 0;
      grupoContaId: number = 0;
      dataInicial: Date = new Date();
      dataFinal: Date = new Date();
      dataCriacaoInicial: Date = new Date();
      dataCriacaoFinal: Date = new Date();
      dataPagamentoInicial: Date = new Date();
      dataPagamentoFinal: Date = new Date();
      dataNotaFiscalInicial: Date = new Date();
      dataNotaFiscalFinal: Date = new Date();
      filtroVencimento: boolean = false;
      filtroCriacao: boolean = false;
      filtroPagamento: boolean = false;
      filtroNotaFiscal: boolean = false;
      filtrarPorVencimento: boolean = false;
      filtrarPorCriacao: boolean = false;
      filtrarPorPagamento: boolean = false;
      filtrarPorNotaFiscal: boolean = false;
      nomeParceiro: string = '';
      descricao: string = '';
      nossoNumero: number = 0;
      numeroDoComprovanteDeVenda: string = '';
      valorParcela: number = 0;
      contaParcelaIds: [] = [];
}
